export default "__VITE_ASSET__D1zeHUQ2__"